import { useQuery } from "@tanstack/react-query";
import { LeadActivity } from "views/leads-id/types";
import { inboxApi } from "views/inbox/api/api";
import { CallRecordingPlayer } from "shared/components/CallRecordingPlayer";
import { formatPhone } from "shared/utils";

const formatDuration = (seconds: number | null | undefined) => {
  if (!seconds || seconds <= 0) return "—";
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, "0")} min`;
};

export const AICallActivityCard = ({
  activity
}: {
  activity: LeadActivity;
}) => {
  const callTranscriptId = activity.metadata.call_transcript_id;
  const agentName = activity.metadata.agent_name;
  const agentPhone = activity.metadata.agent_phone;
  const durationSeconds = activity.metadata.duration_seconds;

  const { data, isLoading, isError } = useQuery({
    queryKey: ["CALL_TRANSCRIPT", callTranscriptId],
    queryFn: () => inboxApi.getCallTranscript(callTranscriptId!),
    enabled: !!callTranscriptId
  });

  const recordingUrl = data?.recording_url;
  const effectiveDuration = data?.recording_duration_seconds ?? durationSeconds;

  const getRecordingFallback = () => {
    if (isLoading) return "Loading recording...";
    if (isError) return "Couldn't load recording";
    return "Recording unavailable";
  };

  return (
    <div className="max-w-md space-y-1">
      <p className="text-sm text-content-400">
        Agent:{" "}
        <span className="text-content-1000 font-medium">
          {agentName || "AI agent"}
          {agentPhone ? ` (${formatPhone(agentPhone)})` : ""}
        </span>
      </p>
      <p className="text-sm text-content-400">
        Duration:{" "}
        <span className="text-content-1000 font-medium">
          {formatDuration(effectiveDuration)}
        </span>
      </p>
      {recordingUrl ? (
        <CallRecordingPlayer
          recordingUrl={recordingUrl}
          durationSeconds={effectiveDuration}
        />
      ) : (
        <p className="text-xs text-content-200">{getRecordingFallback()}</p>
      )}
    </div>
  );
};
